import { Vue, Component } from 'vue-property-decorator';
import { appConfigService } from '@/providers/services/app/app-config';
import { authAPI } from '@/providers/apis/auth/auth';

@Component({
  name: 'facet-library',
  components: {

  },
})

export default class LibraryView extends Vue {

  // -------------------------------------------------------------------------------------
  // Hooks
  private mounted() {
    this.guestAccount();
  }

  // ---------------------------------------------------------------------------------------
  // Methods

  private guestAccount() {
    const guestAccountDetails: any = appConfigService.getGuestAccount();
    const loginDetails = atob(guestAccountDetails);
    const userInfo = loginDetails.split(':');
    const credentials = {
      username: userInfo[0],
      password: userInfo[1],
    };
    authAPI
      .logInWithCredential(credentials.username, credentials.password, '')
      .then(
        (session) => {
          const params = {
            isCompetency: false,
            isResource: false,
          };
          window.localStorage.setItem('isCollab', JSON.stringify(params));
          const urlParams = new URLSearchParams(window.location.search);
          localStorage.setItem('isFacet', 'true');
          // Convert to plain object
          const queryParams: Record<string, string> = {};
          urlParams.forEach((value, key) => {
            queryParams[key] = value;
          });
          // Store in localStorage
          localStorage.setItem('facetQueryParams', JSON.stringify(queryParams));
          this.$access.updateRole(session, true, true);
        });
  }
}
